import { recoverBodyScrollIfStuck } from "@/lib/bodyScrollLock";

const SCROLL_STALL_LIMIT = 30;
const SCROLL_CHECK_INTERVAL_MS = 1000;

function hasOpenModal() {
  if (typeof document === "undefined") return false;

  const selector = [
    "[aria-modal='true'][data-state='open']",
    "[role='dialog'][data-state='open']",
    "[role='alertdialog'][data-state='open']",
    "[data-state='open'][data-vaul-drawer]",
  ].join(",");

  return document.querySelector(selector) !== null;
}

export function startScrollMonitor() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return () => undefined;
  }

  let secondsWithoutScroll = 0;

  const onScroll = () => {
    secondsWithoutScroll = 0;
  };

  window.addEventListener("scroll", onScroll, { passive: true });

  const intervalId = window.setInterval(() => {
    const bodyOverflow = window.getComputedStyle(document.body).overflow;
    const htmlOverflow = window.getComputedStyle(document.documentElement).overflow;
    const scrollBlocked = bodyOverflow === "hidden" || htmlOverflow === "hidden";

    if (scrollBlocked && !hasOpenModal()) {
      secondsWithoutScroll += 1;
    } else {
      secondsWithoutScroll = 0;
    }

    if (secondsWithoutScroll >= SCROLL_STALL_LIMIT) {
      console.error("🚨 SCROLL COMPLETAMENTE TRAVADO! overflow:hidden sem modal aberto.");
      recoverBodyScrollIfStuck();
      secondsWithoutScroll = 0;
    }
  }, SCROLL_CHECK_INTERVAL_MS);

  return () => {
    window.clearInterval(intervalId);
    window.removeEventListener("scroll", onScroll);
  };
}
